<form [formGroup]="form" (ngSubmit)="onGenerate()">
  <div class="row">
    <div *ngFor="let question of autoritaQuestions" [class]="question.size">
      <dynamic-form-field class="form-element" [form]="form" [question]="question"></dynamic-form-field>
    </div>
  </div>
  <div class="titleblock">
    <h3 class="title1levelNoMargin">Singoli Versamenti</h3>
    <p>
      <a href="javascript:void(0)" (click)="onAddVersamento()">
        Aggiungi Versamento <span class="glyphicon glyphicon-plus"></span>
      </a>
    </p>
  </div>
  <div *ngIf="versamentoForms.length == 0">
    <p>Inserire almeno un versamento.</p>
  </div>
  <div class="row" *ngFor="let singoloVersamentoForm of versamentoForms">
    <form [form]="singoloVersamentoForm">
      <div *ngFor="let question of versamentoQuestions" [class]="question.size">
        <dynamic-form-field class="form-element" [form]="singoloVersamentoForm" [question]="question"></dynamic-form-field>
      </div>
      <p class="col-sm-3 col-xs-6 col-sm-offset-9">
        <button type="button" aria-label="Reset" class="btn btn-outline-secondary btn-block"
          (click)="onRemoveVersamento(singoloVersamentoForm)">Rimuovi <span class="glyphicon glyphicon-minus"></span></button>
      </p>
    </form>
  </div>
  <div class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" aria-label="Reset" class="btn btn-outline-secondary btn-block"
        (click)="onReset()">Reset</button>
    </p>
    <p submitButton
      class="col-sm-3 col-xs-6 col-sm-offset-6"
      [labelButton]="'Genera'"
      [disabled]="!canGenerate()"></p>
  </div>
</form>
